import {
  GET_MATERIALS_LIST,
  GET_MATERIAL,
} from '../../actions/materials';

export default function materials(state = {}, action) {
  switch (action.type) {
    case GET_MATERIALS_LIST:
      return Object.assign({}, state, action.payload);
    case GET_MATERIAL:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/materials/index.js